<template>
  <div class="project-listing">
    <vs-prompt
      title="Export To Excel"
      class="export-options"
      @cancel="clearFields"
      @accept="exportToExcel"
      accept-text="Export"
      @close="clearFields"
      :active.sync="activePrompt"
    >
      <vs-input
        v-model="fileName"
        placeholder="Enter File Name.."
        class="w-full"
      />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
    <vs-row class="mb-8" v-if="!userId && !vesselId">
      <vs-col vs-w="12">
        <router-link :to="{ name: 'AddProject' }" v-if="!userId && !vesselId">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="float-right btn-add sm: mb-4 md:m-0"
            v-if="checkPermission('project', 'add')"
            >{{ $t("labels.add_project") }}</vs-button
          >
        </router-link>
        <div class="float-right flex">
          <vs-button
            v-if="$store.state.userInfo.type === 'A'"
            color="maroon"
            type="filled"
            class="btn-color mr-4"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}
          </vs-button>
        </div>
        <div class="float-right flex align-items-center compare-controls">
          <template v-if="!compareMode">
            <vs-button
              color="dark"
              type="filled"
              class="btn-color mr-4"
              icon="code"
              @click="enterCompareMode"
              >{{ $t("labels.compare") }}
            </vs-button>
          </template>
          <template v-else>
            <span class="compare-instruction mr-4"
              >Select 2-3 projects to compare</span
            >
            <span
              class="compare-counter mr-4"
              :class="{ 'compare-counter-active': selectedProjectIds.length >= 2 }"
              >{{ selectedProjectIds.length }} / 3 selected</span
            >
            <vs-button
              color="#999"
              type="border"
              class="mr-4"
              @click="cancelCompareMode"
              >Cancel
            </vs-button>
            <vs-button
              color="dark"
              type="filled"
              class="btn-color mr-4"
              icon="code"
              @click="compareProjects"
              >Compare Now
            </vs-button>
          </template>
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.status") }}</label>
          <v-select
            v-model="filter_status"
            :options="customFilterOptions"
            :reduce="(filtersStatus) => filtersStatus.value"
            label="text"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3" v-if="this.isUserType('A')">
          <label class="pl-1">{{ $t("labels.client") }}</label>
          <v-select
            v-model="client_id"
            :options="filtersClient"
            :reduce="(filtersClient) => filtersClient.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.vessel") }}</label>
          <v-select
            v-model="vessel_id"
            :options="filtersVessel"
            :reduce="(filtersVessel) => filtersVessel.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full justify-center flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="
              !this.search &&
              !this.filter_processing_status &&
              !this.filter_status &&
              !this.filtersClient &&
              !this.filtersVessel
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="
              !this.search &&
              !this.filter_processing_status &&
              !this.filter_status &&
              !this.filtersClient &&
              !this.filtersVessel
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="question-import" v-show="showImport == true">
      <div class="vx-row filter-default">
        <div
          class="vx-col sm: w-full md:w-1/4 flex sm: justify-center md:justify-end"
        >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-download"
            :title="$t('labels.download_sample_csv')"
            @click.prevent="downloadSampleCsv()"
            class="btn-color"
            >{{ $t("labels.sample_import_csv") }}</vs-button
          >
        </div>
        <div class="vx-col sm: w-full md:w-1/3 sm:pl-5">
          <input
            type="file"
            id="file"
            name="importFile"
            class="vs-inputx vs-input--input normal hasValue"
            accept=".csv"
            ref="file"
            v-on:change="handleFileUpload(this)"
            v-validate="'verify_image'"
          />
        </div>
        <div
          class="vx-col sm: w-full md:w-2/5 flex sm: justify-center md:justify-start"
        >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.clear')"
            @click="clearImport()"
            class="sm:ml-0 md:ml-2 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            :title="$t('labels.import_csv')"
            @click.prevent="submitFile()"
            class="sm:ml-0 px-10 btn-color float-left"
            >{{ $t("labels.import") }}
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vs-table search :data="projects" class="permission">
      <template slot="header">
        <div class="set flex">
          <label class="limit_label">{{ $t("labels.show") }}</label>
          <v-select
            v-model="limit"
            :options="limitarr"
            :reduce="(limitarr) => limitarr.value"
            :clearable="false"
            label="text"
            class="px-1"
          />
          <label class="limit_label">{{ $t("labels.projects") }}</label>
        </div>
      </template>
      <template slot="thead">
        <vs-th class="w-1" v-if="compareMode"></vs-th>
        <vs-th sort-key="name" class="w-5">{{ $t("labels.pro_name") }}</vs-th>
        <vs-th sort-key="vessel" class="w-10">{{ $t("labels.vessel") }}</vs-th>
        <vs-th sort-key="services" class="w-15">{{
          $t("labels.inspection")
        }}</vs-th>
        <vs-th sort-key="port" class="w-15">{{ $t("labels.location") }}</vs-th>
        <vs-th sort-key="date" class="w-10">{{ $t("labels.date") }}</vs-th>
        <vs-th sort-key="status_name" class="w-19">{{
          $t("labels.project_status")
        }}</vs-th>
        <vs-th v-if="$store.state.userInfo.type == 'CN'">{{
          $t("labels.my_status")
        }}</vs-th>
        <vs-th class="w-20">{{ $t("labels.action") }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td v-if="compareMode">
            <vs-checkbox
              :disabled="
                selectedProjectIds.length === 3 &&
                !selectedProjectIds.includes(tr.id)
              "
              :checked="selectedProjectIds.includes(tr.id)"
              color="dark"
              @click="selectedProjects($event, tr)"
            ></vs-checkbox>
          </vs-td>
          <vs-td :data="tr.name">
            <router-link
              class="view-link"
              :to="{ name: 'ViewProject', params: { id: tr.id } }"
              v-if="checkPermission('project', 'view')"
            >
              {{ tr.name }}
            </router-link>
          </vs-td>
          <vs-td :data="tr.vessel">
            <router-link
              class="view-link"
              :to="{ name: 'ViewVessel', params: { id: tr.vessel_id } }"
              v-if="checkPermission('vessel', 'view')"
              >{{ tr.vessel }}</router-link
            >
          </vs-td>
          <vs-td
            :data="tr.services"
            class="wx-100 text-truncate"
            :title="tr.services | nameString"
            >{{ tr.services | nameString }}</vs-td
          >
          <vs-td :data="tr.port">{{ tr.port.name }}</vs-td>
          <vs-td :data="tr.date" class="text-nowrap">{{
            tr.date | only_date_format
          }}</vs-td>
          <vs-td :data="tr.status_name">{{ tr.status_name }}</vs-td>
          <vs-td
            :data="tr.consultant_status_name"
            v-if="$store.state.userInfo.type == 'CN'"
            >{{ tr.consultant_status_name }}</vs-td
          >
          <vs-td>
            <div class="flex">
              <router-link
                class="view-link"
                :to="{ name: 'ViewProject', params: { id: tr.id } }"
                v-if="checkPermission('project', 'view')"
                :class="{ disabled: tr.is_old_project != 0 }"
              >
                <vs-button
                  type="flat"
                  :title="$t('labels.view')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-eye"
                  color="dark"
                  class="p-1"
                ></vs-button>
              </router-link>
              <router-link
                class="view-link"
                :to="{ name: 'EditProject', params: { id: tr.id } }"
                v-if="
                  checkPermission('project', 'modify') &&
                  $store.state.userInfo.type == 'A'
                "
                :class="{ disabled: tr.is_old_project != 0 }"
              >
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="p-1"
                  :class="{ disabled: tr.is_old_project != 0 }"
                ></vs-button>
              </router-link>
              <vs-button
                @click="statusPopup(tr)"
                type="flat"
                :title="$t('labels.update_status')"
                size="large"
                icon-pack="feather"
                icon="icon-check-circle"
                class="p-1"
                color="danger"
                :disabled="
                  (isUserType('CL') && tr.status != 'SC') ||
                  tr.is_old_project != 0
                "
                v-show="checkPermission('project', 'modify')"
              ></vs-button>
              <router-link
                class="view-link"
                :to="{ name: 'ReviewReport', params: { project_id: tr.id } }"
                v-if="
                  tr.status !== 'W' &&
                  checkPermission('project', 'modify') &&
                  $store.state.userInfo.type == 'A'
                "
              >
                <vs-button
                  type="flat"
                  :title="$t('labels.review_report')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-file-text"
                  color="danger"
                  class="p-1"
                ></vs-button>
              </router-link>
              <router-link
                class="view-link"
                :to="{ name: 'Inspection', params: { id: tr.id } }"
                v-if="
                  checkPermission('project', 'modify') &&
                  $store.state.userInfo.type !== 'CL'
                "
                :class="{ disabled: tr.is_old_project != 0 }"
              >
                <vs-button
                  type="flat"
                  :title="$t('labels.inspection')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-camera"
                  color="warning"
                  class="p-1"
                ></vs-button>
              </router-link>
              <vs-button
                @click="deleteConfirm(indextr)"
                type="flat"
                :title="$t('labels.delete')"
                size="large"
                icon-pack="feather"
                icon="icon-trash-2"
                color="danger"
                v-show="
                  tr.status !== 'W' &&
                  checkPermission('project', 'delete') &&
                  $store.state.userInfo.type == 'A'
                "
                class="p-1"
                :disabled="tr.is_old_project != 0"
              ></vs-button>
              <vs-button
                v-if="$store.state.userInfo.type == 'CN'"
                color="dark"
                type="flat"
                :title="$t('labels.download')"
                icon-pack="feather"
                icon="icon-download"
                @click="downloadReport(tr)"
                class="p-1"
              >
              </vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="mt-6">
      <vs-pagination
        color="dark"
        :total="totalPage"
        v-model="currentx"
        class="mb-1"
      ></vs-pagination>
    </div>
    <!-- UpdateStatus Popup -->
    <vs-popup
      class="holamundo"
      :title="$t('labels.update_status')"
      :active.sync="popupActive"
    >
      <p class="mb-4">{{ $t("strings.update_status") }}</p>
      <ul class="centerx" v-if="$store.state.userInfo.type == 'A'">
        <li>
          <vs-radio v-model="user_status" vs-value="C">{{
            $t("labels.confirm")
          }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="user_status" vs-value="IRA">{{
            $t("labels.in_review_by_admin")
          }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="user_status" vs-value="A">{{
            $t("labels.approved")
          }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="user_status" vs-value="SC">{{
            $t("labels.sent_to_client")
          }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="user_status" vs-value="WD">{{
            $t("labels.withdraw")
          }}</vs-radio>
        </li>
      </ul>
      <ul class="centerx" v-if="$store.state.userInfo.type == 'CN'">
        <li>
          <vs-radio v-model="user_status" vs-value="IP">{{
            $t("labels.in_progress")
          }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="user_status" vs-value="SR">{{
            $t("labels.sent_for_review")
          }}</vs-radio>
        </li>
      </ul>
      <ul class="centerx" v-if="$store.state.userInfo.type == 'CL'">
        <li>
          <vs-radio v-model="user_status" vs-value="CR">{{
            $t("labels.change_request")
          }}</vs-radio>
        </li>
      </ul>
      <vs-button
        class="vs-component vs-button mt-4 vs-button-primary vs-button-filled login-btn"
        :disabled="button_loading"
        @click.prevent="updateStatus()"
        id="update-status"
        >{{ $t("labels.update_status") }}
      </vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo"
      :title="$t('labels.select_app')"
      :active.sync="popupActiveApp"
    >
      <p class="mb-4">{{ $t("strings.select_app") }}</p>
      <ul class="centerx">
        <li>
          <vs-radio v-model="app_value" vs-value="Linux">{{
            $t("labels.linux")
          }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="app_value" vs-value="Windows">{{
            $t("labels.windows")
          }}</vs-radio>
        </li>
      </ul>
      <vs-button
        class="vs-component vs-button mt-4 vs-button-primary vs-button-filled login-btn"
        :disabled="button_loading"
        @click.prevent="downloadApp()"
        id="download-app"
        >{{ $t("labels.app_download") }}
      </vs-button>
    </vs-popup>
    <!-- </vx-card> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
export default {
  props: ["userId", "vesselId", "status", "clientId"],
  data() {
    return {
      projects: [],
      user_status: null,
      app_value: null,
      isExcel: false,
      popupActive: false,
      popupActiveReview: false,
      popupActiveApp: false,
      currentx: 1,
      totalPage: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      showImport: false,
      search: null,
      file: null,
      vessel: "",
      sample_csv_url: null,
      selectedId: 0,
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Name", "Vessel", "Project Status", "Processigng Status"],
      headerVal: ["name", "vessel", "status_name", "processing_status_name"],
      activePrompt: false,
      app_download: "",
      filter_processing_status: null,
      filtersprocessingStatus: [
        { text: "Not Applicable", value: "NA" },
        { text: "Not done", value: "ND" },
        { text: "In progress", value: "IP" },
        { text: "Done", value: "D" },
      ],
      filter_status: null,
      filtersStatus: [
        { text: "Draft", value: "DR" },
        { text: "Confirmed", value: "C" },
        { text: "In Progress by Consultant", value: "IPCON" },
        { text: "Send for Review by Consultant", value: "SRCON" },
        { text: "In Review by Admin", value: "IRA" },
        { text: "Sent to Client", value: "SC" },
        { text: "Approved", value: "A" },
        { text: "Closed", value: "CL" },
        { text: "Withdraw", value: "WD" },
        { text: "Sent back to Admin", value: "CR" },
      ],
      appDownload: [
        {
          text: "Windows",
          value:
            "https://gms-staging-files.s3.eu-west-2.amazonaws.com/apps/windows/dev-iqcrm-windows-app.zip",
        },
        {
          text: "Linux",
          value:
            "https://gms-staging-files.s3.eu-west-2.amazonaws.com/apps/linux/iqcrm-linux-app.zip",
        },
      ],
      client_id: this.clientId,
      vessel_id: null,
      export: 0,
      filtersClient: [],
      filtersVessel: [],
      input: {},
      selectedProject: null,
    };
  },
  computed: {
    ...mapState({
      selectedProjectIds: (state) => state.comparingProjects,
    }),
    compareMode: {
      get() {
        return this.$store.state.compareMode;
      },
      set(val) {
        this.$store.commit("SET_COMPARE_MODE", val);
      },
    },
    status__in() {
      return this.status === "in-progress"
        ? ["DR", "C", "IPCON", "SRCON", "IRA", "A", "WD", "CR"]
        : ["SC", "CL"];
    },
    customFilterOptions() {
      return this.filtersStatus.filter((v) =>
        this.status__in.includes(v.value)
      );
    },
  },
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getProjects();
    },
    search() {
      this.currentx = 1;
    },
    currentx() {
      this.getProjects();
    },
    showImport(val) {
      if (val) {
        this.showfilter = false;
      }
    },
    showfilter(val) {
      if (val) {
        this.showImport = false;
      }
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getProjects();
    this.getVessel();
    if (this.isUserType("A")) {
      this.getClients();
    }
  },
  methods: {
    exportToExcel() {
      import("@/vendor/Export2Excel").then((excel) => {
        const list = this.projects;
        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.clearFields();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j];
        })
      );
    },
    clearFields() {
      (this.filename = ""),
        (this.cellAutoWidth = true),
        (this.selectedFormat = "xlsx");
    },
    async getProjects(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        processing_status: this.filter_processing_status,
        status: this.filter_status,
        client_id: this.client_id,
        vessel_id: this.vessel_id,
        export: this.export,
      };
      if (this.userId) {
        input = Object.assign(input, {
          client_id: this.userId,
        });
      }
      if (this.vesselId) {
        input = Object.assign(input, {
          vessel_id: this.vesselId,
        });
      }
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      input = {
        ...input,
        status__in: this.status__in,
      };
      let response = await this.getHTTPPostResponse("/projects", input);
      if (exp) {
        this.exportFile(response, "Projects");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let projects = data.projects.map((v) => ({
            ...v,
            services:
              v.is_old_project == 1
                ? [{ name: v.work_instructions }]
                : v.services,
          }));
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          projects.forEach((element) => {
            if (element.vessel) {
              let vessel_name = element.vessel.name;
              element.vessel = vessel_name;
            } else {
              element.vessel = element.vessel;
            }
          });
          this.projects = projects;

          this.sample_csv_url = data.sample_csv;
        }
      }
    },
    async getClients() {
      var input = {
        type: "CL",
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let data = response.data.users;
        let client = data;
        this.filtersClient = client;
      }
    },
    async getVessel() {
      var input = {};
      let response = await this.getHTTPPostResponse("/vessels/list", input);
      if (response) {
        let data = response.data.vessels;
        let vessel = data;
        this.filtersVessel = vessel;
      }
    },
    /* async submitFile() {
        let data = new FormData();
        data.set("file", this.importFile);
        console.log("import", this.importFile);
        let response = await this.getHTTPPostResponse(
          "/projects/import",
          data,
          "",
          true
        );
        if (response) {
          let data = response.data;
          this.showImport = false;
          document.getElementById("file").value = "";
          this.getProjects();
        }
      },
      handleFileUpload() {
        let file = this.$refs.file.files[0]

        if (file.type !== 'text/csv') {

          this.$refs.file.value = '';
        }
        this.importFile = this.$refs.file.files[0];
      }, */
    /* exportCsv() {
        this.getProjects(true);
      }, */
    filter() {
      this.getProjects();
    },
    clearFilter() {
      this.search = null;
      this.filter_processing_status = null;
      this.filter_status = null;
      this.client_id = null;
      this.vessel_id = null;
      this.getProjects();
    },
    /* clearImport() {
        document.getElementById("file").value = "";
        this.getProjects();
      }, */
    // Call API for Update Status
    async statusPopup(trData) {
      this.user_status =
        this.$store.state.userInfo.type == "A"
          ? trData.status
          : trData.consultant_status;
      this.selectedId = trData.id;
      this.popupActive = true;
    },

    async reviewPopup(trData) {
      this.selectedId = trData.id;
      this.popupActiveReview = true;
    },
    async appPopup() {
      this.popupActiveApp = true;
    },
    async updateStatus() {
      let ids = [];
      ids.push(this.selectedId);
      let input = {
        ids: ids,
        status: this.user_status,
      };
      let response = await this.getHTTPPostResponse(
        "/projects/change-status/" + this.selectedId,
        input,
        "#update-status",
        true
      );
      if (response) {
        let data = response.data;
        this.popupActive = false;
        this.user_status = "";
        this.selectedId = 0;
        this.getProjects();
      }
    },
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteProject,
      });
    },
    reportConfirm(index) {
      this.$router.push(`project/add-review-report/${this.selectedId}`);
    },
    async deleteProject() {
      if (this.index < 0) return;
      let url = "projects/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.projects[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getProjects();
      }
    },
    downloadSampleCsv() {
      window.open(this.sample_csv_url, "_self");
    },
    async exportData() {
      let input = {
        processing_status: this.filter_processing_status,
        search: this.search,
        status: this.filter_status,
        client_id: this.client_id,
        export: 1,
      };
      // let response = await this.getHTTPPostResponse("/projects", input);
      this.axios
        .post("/projects", input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;

          this.exportExcelFile(data, "Project");
          this.export = 0;
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
    async downloadApp() {
      this.appDownload.forEach((el) => {
        if (el.text === this.app_value) {
          this.downloadZipApp(el.value, "App");
          this.popupActiveApp = false;
        }
      });
    },
    async downloadReport(index) {
      this.$vs.loading();
      let input = {};
      var formatted_date = new Date().toJSON().slice(0, 10).replace(/-/g, "");
      let pdfName = index.name + "service_reports_" + formatted_date;
      this.axios
        .post("/projects/consultant/report/" + index.id, input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;
          console.log("after download ");
          this.downloadZipFile(data, pdfName);
          this.export = 0;
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
    selectedProjects(event, project) {
      const values = {
        id: project.id,
        checked: event.target.checked,
      };
      this.$store.commit("SET_COMPARING_PROJECTS", values);
    },
    enterCompareMode() {
      this.compareMode = true;
    },
    cancelCompareMode() {
      this.compareMode = false;
      this.$store.commit("CLEAR_COMPARING_PROJECTS");
    },
    compareProjects() {
      const projects = this.$store.state.comparingProjects.length;
      if (projects < 2) {
        this.$vs.notify({
          title: "Minimum Two Project!",
          position: "top-right",
          color: "danger",
        });
        return;
      } else if (projects > 3) {
        this.$vs.notify({
          title: "Maximum Three Projects!",
          position: "top-right",
          color: "danger",
        });
        return;
      }
      const ids = _.join(this.selectedProjectIds, ",");
      this.$router.push({ path: "/compare", query: { ids } });
      this.compareMode = false;
    },
  },
};
</script>
<style scoped lang="scss">
p {
  font-weight: 600;
}
.w-5 {
  width: 5% !important;
}
.w-10 {
  width: 10% !important;
}
.w-15 {
  width: 15% !important;
}
.w-20 {
  width: 20% !important;
}
.includeIconOnly.large {
  width: 35px !important;
  height: 35px !important;
  /* font-size: .7em; */
}
.wx-100 {
  max-width: 150px;
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.compare-controls {
  flex-wrap: wrap;
}
.compare-instruction {
  font-size: 15px;
  color: #495057;
  align-self: center;
}
.compare-counter {
  font-size: 15px;
  font-weight: 600;
  color: #6c757d;
  align-self: center;
}
.compare-counter-active {
  color: #1a7e34;
}
</style>